/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Select_Other_Jobs_EmptyInputs */

const en_register_onboarding_select_other_jobs_empty = /** @type {(inputs: Register_Onboarding_Select_Other_Jobs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No further jobs.`)
};

const de_register_onboarding_select_other_jobs_empty = /** @type {(inputs: Register_Onboarding_Select_Other_Jobs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine weiteren Stellenangebote.`)
};

/**
* | output |
* | --- |
* | "No further jobs." |
*
* @param {Register_Onboarding_Select_Other_Jobs_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_select_other_jobs_empty = /** @type {((inputs?: Register_Onboarding_Select_Other_Jobs_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Select_Other_Jobs_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_select_other_jobs_empty(inputs)
	return en_register_onboarding_select_other_jobs_empty(inputs)
});